<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import Preloader from '@/components/ui/Preloader.vue';

// Browser Back/Forward always fires a native `popstate` event — including
// for catalog filter URLs, which are pushed via router.options.history
// directly (see useCatalogFilters.js) and so never go through vue-router's
// own scrollBehavior hook. Scrolling to top here, rather than relying on
// scrollBehavior, is what covers those filter URLs too.
function scrollToTop() {
  window.scrollTo(0, 0);
}

onMounted(() => {
  // Without this, the browser restores its own remembered scroll position
  // for the entry *before* the popstate event fires, so our jump-to-top
  // would visibly flash from that position first.
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.addEventListener('popstate', scrollToTop);
});

onBeforeUnmount(() => {
  window.removeEventListener('popstate', scrollToTop);
});
</script>

<template>
  <div id="app" class="app">
    <NuxtLayout v-slot="{ className }" class="app__layout">
      <Preloader />
      <NuxtPage :class="className" />
    </NuxtLayout>
  </div>
</template>

<style scoped lang="scss">
.app {
  $parent: &;

  display: flex;
  flex-direction: column;

  &:deep(#{$parent}__layout) {
    flex-grow: 1;
  }
}
</style>
